<template>
  <!--    hero-area-start-->
  <div class="hero-area" style="background-image: url(assets/img/hero-img3.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="hero-containt position-relative">
            <h3>Driving<br />employability</h3>
            <img src="assets/img/u.png" alt="" />
            <h4>{{ textElements.subTitle }}</h4>
            <p>
              {{ textElements.text }}
            </p>
            <div class="hero-btn">
              <a href="https://www.employability-ranking.com/" target="_new">GEURS 2022 / 2023</a>
            </div>

            <div class="hero-global">
              <!-- <p>
                GEURS 2022 / 2023
              </p>
              <a href="https://www.employability-ranking.com/" class="theme-btn" target="_new"
                >View results</a
              > -->
              <p>
                Digital Leaders 2023
              </p>
              <router-link to="/digitalleaders2023" class="theme-btn">View results</router-link>

              <img src="assets/img/glo-bot.png" alt="" class="glo-dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
import { getSingle } from '@/api/navItems';

export default {
  data() {
    return {
      textElements: {}
    };
  },
  created() {
    getSingle('home-entreprises').then(res => {
      this.textElements = res.text_template;
    });
  }
};
</script>

<style lang="scss" scoped>
h3,
h4 {
  margin: 0px 0px 15px;
}

.dl-logo {
  color: rgb(36, 67, 129);
  padding-bottom: 16px;
  font-size: 22px;
  font-weight: bold;
}
</style>
